






















































































































































































































































import Vue, { PropType } from "vue";
import Locale from "@/lib/locale";
import Date from "@/lib/convertDate";
import Price from "@/lib/price";
import TextConverter from "@/lib/textConverter";
import { GetChangeDetailResponse } from "@/containers/changePlans/api";

export interface AboutChangePlansProps {
  changePlansData: GetChangeDetailResponse;
  clipStudioPaintDownloadLink: string;
  lang: any;
  isChangeDevice: boolean;
  deviceTypeOld: string;
  deviceTypeNew: string;
  isChangeDeviceRelatedSmartphone: boolean;
  isDiscountContract: boolean;
  isExToPro: boolean;
  isProToEx: boolean;
  isOnlyTermChange: boolean;
  isSmartPhonePlan: boolean;
  urlHelpDifferenceAmount: string;
  urlHelpChangeDevice: string;
  urlHelpContinuedPatronage: string;
  urlHelpGalaxy: string;
  urlDifferenceInGrade: string;
  urlGradeChange: string;
}

export interface AboutChangePlansData {
  locale: string;
}

export default Vue.extend({
  name: "vc-about-change-plans",
  props: {
    changePlansData: {
      type: Object as PropType<AboutChangePlansProps["changePlansData"]>,
      default: () => {
        return {
          currencyCode: "",
          current: {},
          changePlans: [],
          discountPrice: 0,
          discountRemainMonth: 0,
          discountSettlementScheduledTo: 0,
          instantPayment: 0,
          isDiscount: false,
          firstChangePlanType: "",
          isImmediateNoPriceDifference: false,
          regularSettlementScheduledPrice: 0,
          regularSettlementScheduledFrom: 0,
          settlementScheduledPrice: 0,
          settlementScheduledTerm: "",
          settlementScheduledAt: 0
        };
      }
    },
    clipStudioPaintDownloadLink: {
      type: String as PropType<
        AboutChangePlansProps["clipStudioPaintDownloadLink"]
      >,
      default: ""
    },
    lang: {
      type: Object as PropType<AboutChangePlansProps["lang"]>,
      default: () => {}
    },
    isChangeDevice: {
      type: Boolean as PropType<AboutChangePlansProps["isChangeDevice"]>,
      default: false
    },
    deviceTypeOld: {
      type: String as PropType<AboutChangePlansProps["deviceTypeOld"]>,
      default: ""
    },
    deviceTypeNew: {
      type: String as PropType<AboutChangePlansProps["deviceTypeNew"]>,
      default: ""
    },
    isChangeDeviceRelatedSmartphone: {
      type: Boolean as PropType<
        AboutChangePlansProps["isChangeDeviceRelatedSmartphone"]
      >,
      default: false
    },
    isDiscountContract: {
      type: Boolean as PropType<AboutChangePlansProps["isDiscountContract"]>,
      default: false
    },
    isExToPro: {
      type: Boolean as PropType<AboutChangePlansProps["isExToPro"]>,
      default: false
    },
    isProToEx: {
      type: Boolean as PropType<AboutChangePlansProps["isProToEx"]>,
      default: false
    },
    isOnlyTermChange: {
      type: Boolean as PropType<AboutChangePlansProps["isOnlyTermChange"]>,
      default: false
    },
    isSmartPhonePlan: {
      type: Boolean as PropType<AboutChangePlansProps["isSmartPhonePlan"]>,
      default: false
    },
    urlHelpDifferenceAmount: {
      type: String as PropType<
        AboutChangePlansProps["urlHelpDifferenceAmount"]
      >,
      default: ""
    },
    urlHelpChangeDevice: {
      type: String as PropType<AboutChangePlansProps["urlHelpChangeDevice"]>,
      default: ""
    },
    urlHelpContinuedPatronage: {
      type: String as PropType<
        AboutChangePlansProps["urlHelpContinuedPatronage"]
      >,
      default: ""
    },
    urlHelpGalaxy: {
      type: String as PropType<AboutChangePlansProps["urlHelpGalaxy"]>,
      default: ""
    },
    urlDifferenceInGrade: {
      type: String as PropType<AboutChangePlansProps["urlDifferenceInGrade"]>,
      default: ""
    },
    urlGradeChange: {
      type: String as PropType<AboutChangePlansProps["urlGradeChange"]>,
      default: ""
    }
  },
  data(): AboutChangePlansData {
    return {
      locale: Locale.getLocale()
    };
  },
  methods: {
    replaceResourceText(
      originalText: string,
      replaceKey: string,
      text: string
    ) {
      return originalText.replace(replaceKey, text);
    },
    getConvertDate(timestamp: number) {
      return Date.getDate(timestamp, this.locale, "yyyy/M/d");
    },
    replaceDateText(text: string, replaceKey: string, timestamp: number) {
      return text.replace(replaceKey, this.getConvertDate(timestamp));
    },
    replaceText(text: string, replaceKey: string, replaceText: string) {
      return text.replace(replaceKey, replaceText);
    },
    replaceBr(text: string) {
      return TextConverter.replaceBr(text);
    }
  },
  computed: {
    // 即時お支払い金額
    instantPaymentPrice(): string {
      let instancePrice = this.lang.payment_price;
      instancePrice = instancePrice.replace(
        ":price",
        Price.getPrice(
          this.changePlansData.currencyCode,
          this.changePlansData.instantPayment
        )
      );

      return instancePrice;
    },
    // 次回支払い金額取得
    nextPaymentPrice(): string {
      let nextPaymentPrice = this.lang.monthly_price;
      if (this.changePlansData.settlementScheduledTerm === "year") {
        nextPaymentPrice = this.lang.yearly_price;
      }

      let price = Number(this.changePlansData.settlementScheduledPrice);
      if (this.changePlansData.isDiscount) {
        price = Number(this.changePlansData.regularSettlementScheduledPrice);
      }

      nextPaymentPrice = nextPaymentPrice.replace(
        ":price",
        Price.getPrice(this.changePlansData.currencyCode, price)
      );

      return nextPaymentPrice;
    },
    // 次回支払日取得
    nextSettlementScheduledAt(): string {
      let date = this.changePlansData.settlementScheduledAt;

      if (this.changePlansData.isDiscount) {
        date = this.changePlansData.regularSettlementScheduledFrom;
      }

      return this.lang.next_due_date.replace(
        ":date",
        Date.getDate(date, this.locale, "yyyy/M/d")
      );
    },
    // 割引金額取得
    discountPrice(): string {
      let discountPrice = this.lang.during_discount_offer_payment_price_1;
      discountPrice = discountPrice
        .replace(
          ":old_price",
          "<span class='componentAboutNewPlan__beforeDiscountPrice'>" +
            Price.getPrice(
              this.changePlansData.currencyCode,
              Number(this.changePlansData.regularSettlementScheduledPrice)
            ) +
            "</span>"
        )
        .replace(
          ":new_price",
          Price.getPrice(
            this.changePlansData.currencyCode,
            this.changePlansData.discountPrice
          )
        );

      return discountPrice;
    },
    discountTerm(): string {
      let discountTerm = this.lang.during_discount_offer_payment_price_2;
      discountTerm = discountTerm.replace(
        ":term",
        this.changePlansData.discountRemainMonth
      );

      return discountTerm;
    },
    discountEndDate(): string {
      let discountEndDate = this.lang.during_discount_offer_payment_price_3;
      discountEndDate = discountEndDate.replace(
        ":date",
        this.getConvertDate(this.changePlansData.discountSettlementScheduledTo)
      );

      return discountEndDate;
    },
    changePlanType(): string {
      const changePlans = this.changePlansData.changePlans;
      const changePlan = changePlans.filter((value: any) => {
        return value.order === 1;
      });
      return changePlan.type;
    },
    isImmediate(): boolean {
      return (
        this.changePlansData.firstChangePlanType === "immediate" ||
        this.changePlansData.firstChangePlanType ===
          "immediate_no_price_difference"
      );
    },
    isReservation(): boolean {
      return this.changePlansData.firstChangePlanType === "reservation";
    },
    deviceTypeChangeType(): string {
      const getDeviceTypeRank = (deviceType: string): number => {
        switch (deviceType) {
          case "smartphone":
            return 1;
          case "single":
            return 2;
          case "double":
            return 3;
          case "premium":
            return 4;
          default:
            return 0;
        }
      };

      const changeDiff =
        getDeviceTypeRank(this.deviceTypeNew) -
        getDeviceTypeRank(this.deviceTypeOld);

      if (changeDiff > 0) {
        return "upgrade";
      }
      if (changeDiff < 0) {
        return "downgrade";
      } else {
        return "none";
      }
    }
  }
});
